<template>
  <div>
    <component :is="componentName"/>
  </div>
</template>
<script>
import approvalInvitation from './approval_invitation.vue';
import approvalLetter from './approval_letters.vue';
export default {
  data(){
    return {
      componentName:'',
    }
  },
  components:{
    approvalLetter,
    approvalInvitation,
  },
  mounted(){
    let type = this.$route.query.type;
    if(type == '1' || type == '3'){
      this.componentName = 'approvalInvitation'
    }else if(type == '5'){
      this.componentName = 'approvalLetter'
    }
  }
}
</script>
